import { useState } from "react";

// Read-only for now — units are backfilled directly in the database. CRUD
// (add/edit/delete a unit from the UI) is a later phase.
export function useUnitsData() {
  const [units, setUnits] = useState([]);
  return { units, setUnits };
}
